import Api from '@/api'

// Максимальное время сессии 24 часа
const maxSessionTime = (24 * 60 * 60 * 1000)

export default {
    namespaced: true,
    state: {
        dev: false,
        withoutkey: false,
        autorized: false,
        start: 0,
        token: '',
        role: ''
    },
    getters: {
        isActive (state) {
            if (state.dev || (state.autorized && Date.now() - state.start < maxSessionTime)) {
                return true
            } else {
                return false
            }
        }
    },
    actions: {
        async auth ({state, commit, dispatch}, {token, withoutkey}) {
            await Api.GET('api/main/auth', {token})

            if (state.token !== token) {
                dispatch('reset', null, {root: true})
            }

            commit('auth', {token, withoutkey})
        },
        async authWithoutKey ({dispatch}) {
            let json = await Api.GET('api/user/register')
            await dispatch('auth', {token: json.id, withoutkey: true})
        },
        logout ({commit, dispatch}) {
            commit('logout')
            dispatch('reset', null, {root: true})
        }
    },
    mutations: {
        role (state, role) {
            state.role = role
        },
        auth (state, {id, token, withoutkey}) {
            state.start = Date.now()
            state.id = id
            state.token = token
            state.autorized = true
            state.withoutkey = withoutkey
        },
        logout (state) {
            state.start = 0
            state.id = ''
            state.token = ''
            state.role = ''
            state.autorized = false
            state.withoutkey = false
        }
    }
}
